import { render } from "./ConsultaAvancadaPage.vue?vue&type=template&id=2ac3e5c8&scoped=true"
import script from "./ConsultaAvancadaPage.vue?vue&type=script&lang=js"
export * from "./ConsultaAvancadaPage.vue?vue&type=script&lang=js"

import "./ConsultaAvancadaPage.vue?vue&type=style&index=0&id=2ac3e5c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac3e5c8"]])

export default __exports__